// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"44357718","977":"c258a060"}[chunkId] + ".chunk.js";
};